import { useInView } from "react-intersection-observer";
import { useHotelSlot } from "@b2bportal/core-hotels";
import { useHotelsStyles, useModuleBEM } from "@b2bportal/core-themes";
import {
  CoreHotelsComponent,
  type PlatformComponentProps,
} from "@b2bportal/core-types";
import type { DateRange, Lodging } from "@b2bportal/lodging-api";
import {
  StaysAvailabilityCard,
  useEmitCoreHotelsRawEventOnce,
  HotelsRawEventName,
} from "@tenant/hotels";
import clsx from "clsx";

import defaultStyles from "./HotelListItem.module.scss";

export type HotelListItemProps = {
  hotel: Lodging;
  onHover?: (hotelId: string | undefined) => void;
  dateRange: DateRange;
  rooms?: number;
} & PlatformComponentProps;

export const HotelListItem = ({
  hotel,
  className,
  onHover,
  dateRange,
  rooms,
}: HotelListItemProps) => {
  const styles = useHotelsStyles(
    CoreHotelsComponent.HotelListItem,
    defaultStyles
  );
  const [block] = useModuleBEM(styles, CoreHotelsComponent.HotelListItem, {
    available: hotel.price != null,
  });

  const { ref: containerRef, inView } = useInView();

  const HotelSlot = useHotelSlot();

  useEmitCoreHotelsRawEventOnce(
    {
      name: HotelsRawEventName.HotelViewedLodgingInList,
      properties: {
        hotelId: hotel.lodging.id,
      },
    },
    inView
  );

  return (
    <div className={clsx(block, className)} ref={containerRef}>
      <HotelSlot.HotelLink hotel={hotel}>
        <StaysAvailabilityCard
          hotel={hotel}
          onHover={onHover}
          dateRange={dateRange}
          rooms={rooms}
        />
      </HotelSlot.HotelLink>
    </div>
  );
};
